import { makeStyles } from '@material-ui/core/styles'

export const toolBarSliderStyle = makeStyles((theme) => ({
  discreteSlider: {
    display: 'flex',
    margin: 0,
    marginRight: theme.spacing(2),
    fontSize: '0.7rem',
    alignSelf: 'left',
    whiteSpace: 'nowrap',
    color: theme.palette.geoColors.toolBar.main,
    height: 15
  },
  slider: {
    color: theme.palette.primary.main,
    paddingTop: 10
  },
  sliderContainer: {
    maxWidth: 200,
    display: 'flex',
    flexDirection: 'row'
  },
  input: {
    padding: 0,
    width: 60,
    textAlign: 'center',
    fontSize: '0.9rem',
    marginLeft: theme.spacing(1),
    height: 22,
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.geoColors.toolBar.light,
    '& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none'
    }
  },
  unit: {
    fontSize: '0.9rem',
    marginLeft: theme.spacing(0.5),
    height: 20,
    lineHeight: '20px'
  }
}))
